!function(e) {
    var i = {};
    function t(a) {
        if (i[a])
            return i[a].exports;
        var o = i[a] = {
            i: a,
            l: !1,
            exports: {}
        };
        return e[a].call(o.exports, o, o.exports, t),
        o.l = !0,
        o.exports
    }
    t.m = e,
    t.c = i,
    t.d = function(e, i, a) {
        t.o(e, i) || Object.defineProperty(e, i, {
            enumerable: !0,
            get: a
        })
    }
    ,
    t.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }),
        Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }
    ,
    t.t = function(e, i) {
        if (1 & i && (e = t(e)),
        8 & i)
            return e;
        if (4 & i && "object" == typeof e && e && e.__esModule)
            return e;
        var a = Object.create(null);
        if (t.r(a),
        Object.defineProperty(a, "default", {
            enumerable: !0,
            value: e
        }),
        2 & i && "string" != typeof e)
            for (var o in e)
                t.d(a, o, function(i) {
                    return e[i]
                }
                .bind(null, o));
        return a
    }
    ,
    t.n = function(e) {
        var i = e && e.__esModule ? function() {
            return e.default
        }
        : function() {
            return e
        }
        ;
        return t.d(i, "a", i),
        i
    }
    ,
    t.o = function(e, i) {
        return Object.prototype.hasOwnProperty.call(e, i)
    }
    ,
    t.p = "/",
    t(t.s = 0)
}([function(e, i, t) {
    t(1),
    e.exports = t(2)
}
, function(e, i) {
    window.Zapiet = window.Zapiet || {},
    Zapiet.DeliveryValidator = {
        isEligible: !1,
        languageCode: "en",
        styles: "#zapiet-delivery-validator #zapiet-delivery-validator__topbar{position:absolute;top:0;left:0;right:0;display:flex;background:rgba(0,0,0,.7);align-items:center;justify-content:center;padding:.5em 0;z-index:99998}#zapiet-delivery-validator #zapiet-delivery-validator__topbar.zapiet-delivery-validator__sticky{position:fixed}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container{display:flex;align-items:center;justify-content:center;color:#fff;width:100%}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form{width:100%;padding:0 1em;margin:0}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form #zapiet-delivery-validator__label{display:block}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form .zapiet-delivery-validator__fields{display:flex}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form .zapiet-delivery-validator__fields #zapiet-delivery-validator__postal_code{border-radius:5px;font-size:1em;flex-grow:1;margin:0 .5em 0 0;border:1px solid #fff;text-indent:.5em;background:#fff;color:#333}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form .zapiet-delivery-validator__fields #zapiet-delivery-validator__postal_code::-webkit-input-placeholder{font-size:.9em}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form .zapiet-delivery-validator__fields .zapiet-delivery-validator__submit{color:#fff;padding:.5em 1em;background:#383838;border-color:#383838;border-radius:5px}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form .zapiet-delivery-validator__fields .zapiet-delivery-validator__submit #zapiet-delivery-validator__loading{display:flex}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__close{display:flex;padding:.5em 0 .5em .5em}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__close svg{fill:#fff}#zapiet-delivery-validator #zapiet-delivery-validator__modal{z-index:99999;background:rgba(0,0,0,.5);display:flex;justify-content:center;flex-direction:column;position:fixed;top:0;bottom:0;left:0;right:0}#zapiet-delivery-validator #zapiet-delivery-validator__modal #zapiet-delivery-validator__modal__primary-action{background:#383838;border-color:#383838;color:#fff;padding:.5em 1.5em;border-radius:5px}#zapiet-delivery-validator #zapiet-delivery-validator__modal .zapiet-delivery-validator__modal__container{border-radius:5px;box-shadow:0 1px 4px rgba(0,0,0,.5);background:#fff;margin:0 auto;display:flex;padding:1.5em;flex-direction:column;text-align:center}#zapiet-delivery-validator #zapiet-delivery-validator__modal .zapiet-delivery-validator__modal__container #zapiet-delivery-validator__modal__container__heading{font-size:1.3em}#zapiet-delivery-validator #zapiet-delivery-validator__modal .zapiet-delivery-validator__modal__container #zapiet-delivery-validator__modal__container__content{font-size:1em}#zapiet-delivery-validator #zapiet-delivery-validator__modal .zapiet-delivery-validator__modal__container #zapiet-delivery-validator__modal__container__footer{margin-top:1em;display:flex;justify-content:center}@media (min-width:900px){#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container{max-width:600px}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form{display:flex;align-items:center}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form #zapiet-delivery-validator__label{display:initial;margin-right:.5em}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__container #zapiet-delivery-validator__form .zapiet-delivery-validator__fields{flex-grow:1}#zapiet-delivery-validator #zapiet-delivery-validator__topbar #zapiet-delivery-validator__close{position:absolute;right:1em}#zapiet-delivery-validator #zapiet-delivery-validator__modal .zapiet-delivery-validator__modal__container{max-width:800px;min-width:460px}#zapiet-delivery-validator #zapiet-delivery-validator__modal .zapiet-delivery-validator__modal__container #zapiet-delivery-validator__modal__container__heading{font-size:1.5em}}",
        template: '<div id="zapiet-delivery-validator">\n        <div id="zapiet-delivery-validator__topbar" style="display: none">\n          <div id="zapiet-delivery-validator__container">\n            <form id="zapiet-delivery-validator__form" onSubmit="return Zapiet.DeliveryValidator.internalCheckEligiblity()">\n              <span id="zapiet-delivery-validator__label"></span>\n              <div class="zapiet-delivery-validator__fields">\n                <input type="text" id="zapiet-delivery-validator__postal_code" />\n                <button type="submit" class="zapiet-delivery-validator__submit">\n                  <span id="zapiet-delivery-validator__button_label"></span>\n                  <span id="zapiet-delivery-validator__loading" style="display: none">\n                    <svg width="18" height="18" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"><stop stop-color="#fff" stop-opacity="0" offset="0%"/><stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/><stop stop-color="#fff" offset="100%"/></linearGradient></defs><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><path d="M36 18c0-9.94-8.06-18-18-18" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></path><circle fill="#fff" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></circle></g></svg>\n                  </span>\n                </button>\n                <a href="#" id="zapiet-delivery-validator__close" class="zapiet-delivery-validator__close">\n                  <svg class="zapiet-delivery-validator__close" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 10.293l5.293-5.293.707.707-5.293 5.293 5.293 5.293-.707.707-5.293-5.293-5.293 5.293-.707-.707 5.293-5.293-5.293-5.293.707-.707 5.293 5.293z"/></svg>\n                </a>\n              </div>\n            </form>\n          </div>\n        </div>\n        <div id="zapiet-delivery-validator__modal" style="display: none">\n          <div class="zapiet-delivery-validator__modal__container">\n            <div class="zapiet-delivery-validator__modal__container__heading">\n              <h2 id="zapiet-delivery-validator__modal__container__heading"></h2>\n            </div>\n            <div id="zapiet-delivery-validator__modal__container__content"></div>\n            <div id="zapiet-delivery-validator__modal__container__footer">\n              <a href="#" id="zapiet-delivery-validator__modal__primary-action" onClick="Zapiet.DeliveryValidator.primaryModalAction()"></a>\n            </div>\n          </div>\n        </div>\n      </div>',
        init: function(e) {
            if (!1 === e.enabled)
                return !0;
            this.languageCode = e.languageCode,
            this.addStyles(e.styles),
            this.addTemplate(e.template),
            document.getElementById("zapiet-delivery-validator__label").textContent = this.getTranslation("prelude"),
            document.getElementById("zapiet-delivery-validator__postal_code").placeholder = this.getTranslation("placeholder"),
            document.getElementById("zapiet-delivery-validator__button_label").textContent = this.getTranslation("button_label"),
            this.setupEventListeners(),
            e.sticky && document.getElementById("zapiet-delivery-validator__topbar").classList.add("zapiet-delivery-validator__sticky"),
            e.showOnPageLoad && !sessionStorage.getItem(Shopify.shop + "zapiet-delivery-validator-manually_closed") && this.showTopBar()
        },
        appendHtml: function(e, i) {
            var t = document.createElement("div");
            for (t.innerHTML = i; t.children.length > 0; )
                e.appendChild(t.children[0])
        },
        addTemplate: function(e) {
            return void 0 === e ? (this.appendHtml(document.body, this.template),
            !0) : this.appendHtml(document.body, e)
        },
        addStyles: function(e) {
            void 0 === e && (e = this.styles);
            var i = document.createElement("style");
            i.type = "text/css",
            i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e)),
            document.getElementsByTagName("head")[0].appendChild(i)
        },
        setupEventListeners: function() {
            var e = this;
            document.addEventListener("click", function(i) {
                i.target.matches(".zapiet-delivery-validator__close") && (i.preventDefault(),
                e.hideTopBar())
            }, !1),
            document.addEventListener("click", function(i) {
                i.target.matches(".zapiet-delivery-validator__open") && (i.preventDefault(),
                e.showTopBar())
            }, !1)
        },
        checkEligiblity: function(e, i, t, a) {
            var o = "api-us" === ZapietCachedSettings.cached_config.api_region
              , l = "https://api.zapiet.com/v4.0/delivery/locations?shop=".concat(Shopify.shop, "&geoSearchQuery=").concat(e);
            o && (l = "https://api-us.zapiet.com/v1.0/delivery/locations?shop=".concat(Shopify.shop, "&geoSearchQuery=").concat(e)),
            fetch(l).then(function(e) {
                return 200 !== e.status ? (void 0 !== t && t(e),
                !1) : o ? (e.json().then(function(a) {
                    return void 0 !== a.error ? (t(e),
                    !1) : (i(e),
                    !0)
                }),
                !1) : void e.json().then(function(t) {
                    return void 0 !== i && i(e),
                    !0
                })
            }).catch(function(e) {
                return void 0 !== a && a(e),
                !1
            })
        },
        internalCheckEligiblity: function() {
            var e = this
              , i = document.getElementById("zapiet-delivery-validator__postal_code").value;
            if (document.getElementById("zapiet-delivery-validator__postal_code").blur(),
            !this.doesZipcodeExist(i))
                return !1;
            this.showLoadingIcon();
            var t = "api-us" === ZapietCachedSettings.cached_config.api_region
              , a = "https://api.zapiet.com/v4.0/delivery/locations?shop=".concat(Shopify.shop, "&geoSearchQuery=").concat(i);
            return t && (a = "https://api-us.zapiet.com/v1.0/delivery/locations?shop=".concat(Shopify.shop, "&geoSearchQuery=").concat(i)),
            fetch(a).then(function(i) {
                if (e.hideLoadingIcon(),
                200 === i.status)
                    return t ? (i.json().then(function(i) {
                        void 0 === i.error ? e.eligibleForDelivery(i) : e.notEligibleForDelivery()
                    }),
                    !1) : void i.json().then(function(i) {
                        e.eligibleForDelivery(i)
                    });
                e.notEligibleForDelivery()
            }).catch(function(i) {
                e.hideLoadingIcon(),
                e.error(i)
            }),
            !1
        },
        primaryModalAction: function() {
            this.hideModal()
        },
        hideTopBar: function() {
            document.body.style.paddingTop = "0",
            document.getElementById("zapiet-delivery-validator__topbar").style.display = "none",
            sessionStorage.setItem(Shopify.shop + "zapiet-delivery-validator-manually_closed", !0),
            ZapietEvent.fire("delivery.validator_widget.top_bar.closed")
        },
        showTopBar: function() {
            document.getElementById("zapiet-delivery-validator__topbar").style.display = "flex",
            document.body.style.paddingTop = document.getElementById("zapiet-delivery-validator__topbar").clientHeight + "px",
            sessionStorage.removeItem(Shopify.shop + "zapiet-delivery-validator-manually_closed"),
            ZapietEvent.fire("delivery.validator_widget.top_bar.opened")
        },
        hideModal: function() {
            document.getElementById("zapiet-delivery-validator__modal").style.display = "none",
            ZapietEvent.fire("delivery.validator_widget.modal.closed", {
                isEligible: this.isEligible
            })
        },
        showModal: function() {
            document.getElementById("zapiet-delivery-validator__modal").style.display = "flex",
            ZapietEvent.fire("delivery.validator_widget.modal.opened")
        },
        hideLoadingIcon: function() {
            document.getElementById("zapiet-delivery-validator__loading").style.display = "none",
            document.getElementById("zapiet-delivery-validator__button_label").style.display = "block"
        },
        showLoadingIcon: function() {
            document.getElementById("zapiet-delivery-validator__loading").style.display = "block",
            document.getElementById("zapiet-delivery-validator__button_label").style.display = "none"
        },
        updateModalContent: function(e, i, t) {
            document.getElementById("zapiet-delivery-validator__modal__container__heading").innerHTML = e,
            document.getElementById("zapiet-delivery-validator__modal__container__content").innerHTML = i,
            document.getElementById("zapiet-delivery-validator__modal__primary-action").textContent = t,
            ZapietEvent.fire("delivery.validator_widget.modal.content_updated")
        },
        eligibleForDelivery: function(e) {
            this.isEligible = !0,
            this.updateModalContent(this.getTranslation("eligible_heading"), this.getTranslation("eligible_content"), this.getTranslation("eligible_button_label")),
            this.showModal(),
            ZapietEvent.fire("delivery.validator_widget.eligible", e)
        },
        notEligibleForDelivery: function() {
            this.isEligible = !1,
            this.updateModalContent(this.getTranslation("not_eligible_heading"), this.getTranslation("not_eligible_content"), this.getTranslation("not_eligible_button_label")),
            this.showModal(),
            ZapietEvent.fire("delivery.validator_widget.not_eligible")
        },
        error: function() {
            this.isEligible = !1,
            this.updateModalContent(this.getTranslation("error_heading"), this.getTranslation("error_content"), this.getTranslation("error_button_label")),
            this.showModal(),
            ZapietEvent.fire("delivery.validator_widget.error")
        },
        doesZipcodeExist: function(e) {
            return e.length > 2
        },
        getTranslation: function(e) {
            return ZapietCachedSettings.cached_config.translations.delivery["delivery_validator_" + e]
        }
    },
    void 0 !== window.Zapiet && void 0 !== window.ZapietCachedSettings && void 0 !== window.ZapietCachedSettings.cached_config && void 0 !== window.ZapietCachedSettings.cached_config.delivery_validator && void 0 !== window.Zapiet.DeliveryValidator ? Zapiet.DeliveryValidator.init({
        enabled: ZapietCachedSettings.cached_config.delivery_validator.enabled,
        languageCode: ZapietCachedSettings.language_code,
        showOnPageLoad: ZapietCachedSettings.cached_config.delivery_validator.show_on_page_load,
        sticky: ZapietCachedSettings.cached_config.delivery_validator.sticky
    }) : console.warn("Zapiet - Delivery Validator widget can not load as some settings are missing. Please ensure Store Pickup + Delivery is correctly installed by contacting support@zapiet.com.")
}
, function(e, i) {}
]);
